var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0076d6;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_",
    "data-name": "&lt;Radial Repeat&gt;"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.9,219.1c6.3,6.9,11.9,14.6,16.7,23.2,32.5,58.5,11.3,132.2-47.1,164.6-33.7,18.7-72.4,19.6-105.3,5.9,34.5,21.1,82,22.4,123.3-.5,58.5-32.5,82.4-101.2,53.4-153.5-9.7-17.4-24-30.8-40.9-39.7Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-2",
    "data-name": "&lt;Radial Repeat&gt;"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M314,262.6c.4,9.3-.2,18.8-2.1,28.5-12.7,65.6-76.3,108.5-142,95.8-37.8-7.4-68-31.5-84.5-63.2,12.9,38.4,48.4,69.8,94.7,78.9,65.6,12.7,128.1-24.5,139.5-83.3,3.7-19.6,1.4-39-5.8-56.7Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-3",
    "data-name": "&lt;Radial Repeat&gt;"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292.1,301c-5.7,7.4-12.3,14.3-19.9,20.4-51.9,42.1-128.2,34.1-170.3-17.9-24.2-29.9-31.8-67.8-24-102.7-14.7,37.7-7.8,84.6,21.9,121.3,42.1,51.9,113.9,63.6,160.4,25.9,15.4-12.5,26.1-28.9,32-47.1Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-4",
    "data-name": "&lt;Radial Repeat&gt;"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250.6,316.4c-9.1,2-18.6,3-28.4,2.9-66.8-1.1-120.2-56.3-119-123.2.6-38.5,19.2-72.5,47.5-94.1-35.6,19.4-60.4,59.8-61.2,107-1.1,66.8,46.4,121.9,106.2,123,19.9.2,38.6-5.4,54.8-15.6Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-5",
    "data-name": "&lt;Radial Repeat&gt;"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209,301.5c-8.3-4.3-16.2-9.7-23.6-16-50.5-43.8-55.9-120.4-12-170.9,25.2-29,61.3-43.1,97-41.5-39.7-8-84.7,7.1-115.7,42.6-43.8,50.5-42.8,123.2,2.3,162.5,15,13,32.9,20.7,51.9,23.3Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-6",
    "data-name": "&lt;Radial Repeat&gt;"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M186.7,263.4c-3.6-8.7-6.2-17.8-7.7-27.4-10.5-66.1,34.5-128.2,100.6-138.6,38-6,74.7,6.3,101,30.5-25.2-31.7-69.4-49.1-116-41.7-66,10.5-112,66.8-102.6,126,3,19.5,11.9,37,24.7,51.1Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-7",
    "data-name": "&lt;Radial Repeat&gt;"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M194.1,219.8c2.8-8.9,6.7-17.6,11.7-26,34.5-57.3,108.9-75.9,166.2-41.4,33,19.8,53.1,52.8,57.7,88.3,1-40.5-21.6-82.2-62-106.4-57.3-34.5-128.8-20.8-159.6,30.5-10.2,17-14.7,36-13.9,55.1Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-8",
    "data-name": "&lt;Radial Repeat&gt;"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M227.7,191.2c7.9-5,16.4-9.2,25.7-12.3,63.2-21.8,132.2,11.8,154,75,12.5,36.4,6.7,74.6-12.5,104.8,26.8-30.4,36.3-76.9,20.9-121.4-21.8-63.2-85.3-98.7-141.9-79.2-18.8,6.4-34.5,18.1-46.2,33.2Z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-9",
    "data-name": "&lt;Radial Repeat&gt;"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M272,190.9c9.3,1.2,18.5,3.5,27.7,7.1,62.4,24,93.6,94,69.7,156.5-13.8,35.9-42.8,61.5-76.9,72.2,40-6.1,77.2-35.6,94.1-79.6,24-62.4-1.9-130.4-57.8-151.9-18.7-7.2-38.2-8.3-56.8-4.2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3435f514f83b5a9a62ffa4e1885c15f7.svg";
export { ForwardRef as ReactComponent };